import * as React from 'react';
import { useState } from 'react';
import { Button, Field, Textarea, makeStyles } from '@fluentui/react-components';

/* global HTMLTextAreaElement */

interface CustomInstructionProps {
  disabled: boolean;
  onSubmit: (instruction: string) => void;
}

const useStyles = makeStyles({
  root: {
    marginTop: '12px',
    marginBottom: '12px',
  },
  row: {
    display: 'flex',
    gap: '8px',
    marginTop: '6px',
  },
  textarea: {
    flex: 1,
  },
});

const CustomInstruction: React.FC<CustomInstructionProps> = ({ disabled, onSubmit }) => {
  const styles = useStyles();
  const [value, setValue] = useState('');

  const handleRun = () => {
    const trimmed = value.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
  };

  return (
    <div className={styles.root}>
      <Field label="Custom instruction" hint="Describe your desired change or edit">
        <Textarea
          className={styles.textarea}
          value={value}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setValue(e.target.value)}
          placeholder={'e.g. "Rewrite to favor licensee on IP ownership"'}
          rows={2}
          disabled={disabled}
        />
      </Field>
      <div className={styles.row}>
        <Button appearance="primary" disabled={disabled || !value.trim()} onClick={handleRun}>
          Run custom instruction
        </Button>
      </div>
    </div>
  );
};

export default CustomInstruction;
